/**
 * 分类模块
 * 导出至'@/http/service/category'
 */
import http from '../http'
import url from '../url'

// 个人中心信息
export const myManageinfo = (data, noLogin) => {
  return http.request({
    url: url.myManage,
    method: 'get',
    params: { '_t': Date.now() },
    noLogin
  })
}
// 查询店铺主是否为企业
export const storeEconKind = (data, noLogin) => {
  return http.request({
    url: url.storeEconKind,
    method: 'get',
    params: { '_t': Date.now() },
    noLogin
  })
}
// 用户身份查询
export const queryIdentity = params => {
  return http.request({
    url: url.GET_IDENTIFY_INFO,
    method: 'get',
    params
  })
}

// 查询用户昵称/头像
export const getUserDisplayInfo = params => {
  return http.request({
    url: url.userDisplayInfo,
    method: 'get',
    params
  })
}

// 个人中心信息
export const getOrderCount = data => {
  return http.request({
    url: url.getOrderCount,
    method: 'get',
    params: {
      chId: 60
    }
  })
}

// 个人中心 - 钱包信息
export const getWallet = data => {
  return http.request({
    url: url.wallet,
    method: 'get',
    params: {}
  })
}

// 个人中心 - 营收模块 判断绑卡
export const checkBindByType = params => {
  return http.request({
    url: url.checkBindByType,
    method: 'get',
    params
  })
}

// 个人中心 - 营收模块 信息汇总
export const getComminsionSumInfo = (data) => {
  return http.request({
    url: url.getComminsionSumInfo,
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 个人中心 - 营收模块 账单列表
export const getGoodsAmountList = (data) => {
  return http.request({
    url: url.getGoodsAmountList,
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 个人中心 - 营收模块 服务费信息
export const getServiceCharge = (params) => {
  return http.request({
    url: url.getServiceCharge,
    method: 'get',
    params
  })
}
// 今日任务详细信息
export const getDailyTaskDetail = params => {
  return http.request({
    url: url.getDailyTaskDetail,
    method: 'get',
    params,
  })
}

// 今日任务分享完成
export const dailyTaskShare = params => {
  return http.request({
    url: url.dailyTaskShare,
    method: 'get',
    params,
  })
}

// 今日任务列表
export const getDailyTask = params => {
  return http.request({
    url: url.getDailyTask,
    method: 'get',
    params,
  })
}
// 新移动工作台-修改密码
export const updatePassword = (params) => {
  return http.request({
    url: url.UPDATE_PASSWORD,
    method: 'get',
    params
  })
}

// 新移动工作台-找回密码发送短信验证码
export const getSmsCode = (params) => {
  return http.request({
    url: url.GET_RESETSMS,
    method: 'get',
    params
  })
}

// 新移动工作台-忘记密码
// export const findPassword = (params) => {
//   return http.request({
//     url: url.findPassword,
//     method: 'post',
//     params
//   })
// }

// 新移动工作台-校验验证码
export const checkSmsCode = (params) => {
  return http.request({
    url: url.CHECK_RESETSMS,
    method: 'get',
    params
  })
}

// 新移动工作台-提交新密码
export const submitNewPwd = (params) => {
  return http.request({
    url: url.SUBMIT_RESET,
    method: 'get',
    params
  })
}
export const getMyCardCount = () => {
  return http.request({
    url: url.getMyCardCount,
    method: 'get',
  })
}

// 佣金货款账单详情
export const getGoodsAmountDetail = (data) => {
  return http.request({
    url: url.getGoodsAmountDetail,
    method: 'POST',
    data,
  })
}
// 变更提醒查询
export const changeRemindRecord = (params) => {
  return http.request({
    url: url.changeRemindRecord,
    method: 'get',
    params,
  })
}
// 记录协议签订
export const signAgreement = (data) => {
  return http.request({
    url: url.signAgreement,
    method: 'POST',
    data,
  })
}

// 我的评价列表
export const getMemberComments = (data) => {
  return http.request({
    url: url.getMemberComments,
    method: 'POST',
    data,
  })
}

//删除我的评价
export const delMemberComments = (params) => {
  return http.request({
    url: url.delMemberComments,
    method: 'get',
    params,
  })
}

